import type { TextFieldOnChangeArguments } from 'uikit';
import { TextField } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import type { Dispatch, SetStateAction } from 'react';
import { useCallback, useMemo } from 'react';

import Styles from '../AddWorkUerFrom.module.css';

export interface ICommonValueNoteCellRenderer<T extends { id: number }> extends ICellRendererParams<T> {
    valuesNotes: Record<string, string>;
    setValuesNotes: Dispatch<SetStateAction<Record<string, string>>>;
    checkedIds?: number[];
}

export const CommonValueNoteCellRenderer = <T extends { id: number }>(props: ICommonValueNoteCellRenderer<T>) => {
    const { valuesNotes, setValuesNotes, data, checkedIds } = props;

    const currentValue = useMemo(() => (data ? valuesNotes[data?.id] : ''), [data, valuesNotes]);

    const disabled = useMemo(() => !data?.id || !checkedIds?.includes(data?.id), [checkedIds, data?.id]);

    const onChange = useCallback(
        ({ value }: TextFieldOnChangeArguments) => {
            setValuesNotes((prevState) => {
                if (data?.id) {
                    return {
                        ...prevState,
                        [data.id]: value,
                    };
                }

                return prevState;
            });
        },
        [data?.id, setValuesNotes],
    );

    return (
        <div className={Styles.noteCell}>
            <TextField
                value={currentValue}
                onChange={onChange}
                disabled={disabled}
                placeholder={disabled ? '' : 'Введите'}
                size="s"
            />
        </div>
    );
};

CommonValueNoteCellRenderer.displayName = 'CommonValueNoteCellRenderer';
